import React from "react";

export interface LayoutContextProps {
    downloadOption: string;
    setDownloadOption: React.Dispatch<React.SetStateAction<string>>;
  }
  
export const LayoutContext = React.createContext<LayoutContextProps | undefined>(undefined);